import {
  enumInventoryPeriodSortOption,
  InventoryPeriodSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { inventoryPeriodsQueryAtom } from '../_graphql/queryInventoryPeriods';

import { atomFromQueryString } from '~/shared/state';

export const $selectedFacility = atomFromQueryString.string('f');
export const $selectedStatus = atomFromQueryString.string('status');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

export const $currentSorting = atom<InventoryPeriodSortOption[]>([
  enumInventoryPeriodSortOption.StartDateDesc,
]);

export const $remoteInventoryPeriods = inventoryPeriodsQueryAtom((get) => {
  const selectedFacility = get($selectedFacility);
  const selectedStatus = get($selectedStatus);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    facilityIds?: string[];
    status?: string;
    limit: number;
    offset: number;
    sorting: InventoryPeriodSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityIds = [selectedFacility];
  }
  if (selectedStatus && selectedStatus !== 'all') {
    params.status = selectedStatus;
  }

  return {
    variables: params,
  };
});
